import type { ComponentProps } from "react";
import { DeleteOutlined, DownOutlined } from "@ant-design/icons";
import { Button, Dropdown } from "antd";

const LABEL_SUBMIT = "Publish";
const LABEL_UPDATE = "Update";
const LABEL_DELETE_SCHEDULE = "Delete";

const DELETE_MENU_ITEMS = (onDelete: () => void) => [
  {
    key: "delete",
    icon: <DeleteOutlined />,
    label: LABEL_DELETE_SCHEDULE,
    danger: true,
    onClick: () => onDelete(),
  },
];

type Props = {
  isUpdate: boolean;
  isLoading: boolean;
  isDeleting: boolean;
  onDelete: () => void;
};

type SubmitDropdownButtonProps = Omit<
  ComponentProps<typeof Dropdown.Button>,
  "children"
>;

type SubmitPrimaryButtonProps = Omit<ComponentProps<typeof Button>, "children">;

const SubmitButton = ({
  isUpdate,
  isLoading,
  isDeleting,
  onDelete,
}: Props) => {
  if (isUpdate) {
    const dropdownButtonProps: SubmitDropdownButtonProps = {
      type: "primary",
      icon: <DownOutlined />,
      menu: { items: DELETE_MENU_ITEMS(onDelete) },
      htmlType: "submit",
      loading: isLoading,
      disabled: isDeleting,
      trigger: ["click"],
    };

    return (
      <Dropdown.Button {...dropdownButtonProps}>
        {LABEL_UPDATE}
      </Dropdown.Button>
    );
  }

  const buttonProps: SubmitPrimaryButtonProps = {
    type: "primary",
    htmlType: "submit",
    loading: isLoading,
    disabled: isDeleting,
  };

  return (
    <Button {...buttonProps}>
      {LABEL_SUBMIT}
    </Button>
  );
};

export default SubmitButton;
